<template>
  <div id="ecommerce_product">
    <div class="container-fluid">
      <div class="row" v-if="categorylist.length > 0">
        <div class="col-sm-6" style="margin-bottom: 5px"></div>
        <div class="col-sm-6 form-inline text-right">
          <input type="text" class="form-control" v-model="search" placeholder="Search" />
        </div>
      </div>
      <template v-if="loadingCategory">
        <div style="padding: 30px 0">
          <scale-loader :color="$vuetify.theme.primary" height="45px" width="7px"></scale-loader>
        </div>
      </template>
      <template v-else-if="categorylist.length == 0">
        <div class="text-center" style="margin: 35px 0">
          <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 230px" />
          <h3>{{ $t('create your first category') }}</h3>
          <p>Click "Add Category" to create a category and add products</p>
          <a href="javascript:void(0);" class="btn btn-primary" @click="showCategory = true"
            >Add Category</a
          >
        </div>
      </template>
      <template v-else>
        <div class="row pb-2">
          <div class="col col-sm-12" style="margin-top: 15px">
            <div class="row" style="margin-bottom: 15px">
              <div class="col-xs-6">Categories</div>
              <div class="col col-xs-6 text-right">
                <button class="btn btn-primary" @click="showCategory = true">
                  <em class="fa fa-plus middle" /> Add Category
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <filter-category
                  :categories="categorylist"
                  v-model="currentCategory"
                  @onChangeCategory="onChangeCategory"
                  :stat="filterBadge"
                ></filter-category>
              </div>
            </div>
          </div>
        </div>
        <hr />

        <template v-if="currentCategory && currentCategory != null">
          <div class="row" style="margin-bottom: 15px">
            <div class="col-xs-6">Places</div>
            <div class="col col-xs-6 text-right">
              <button class="btn btn-primary" data-toggle="modal" data-target="#modal_add_product">
                <em class="fa fa-plus middle" /> Add Place
              </button>
            </div>
          </div>
          <template v-if="!loadingProduct">
            <template v-if="filterProducts.length > 0">
              <div class="row">
                <product
                  v-for="(product, index) in filterProducts"
                  :key="'product_' + product.id"
                  v-model="filterProducts[index]"
                  @productDeleted="onDeleteProduct(index)"
                  :category="categorylist"
                  :selectCategory="currentCategory"
                ></product>
              </div>
            </template>

            <template v-else>
              <div role="alert">
                <div class="text-center" style="margin: 35px 0">
                  <img src="/static/img/assets/event/pin.png" alt style="width: 230px" />
                  <h3>Let's add a place</h3>
                  <p>Click "Add Place" to start adding place to your customers</p>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#modal_add_product"
                    >Add Place</a
                  >
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div style="padding: 30px 0">
              <scale-loader
                :color="$vuetify.theme.primary"
                height="45px"
                width="7px"
              ></scale-loader>
            </div>
          </template>

          <modal-add-product
            :selectCategory="currentCategory"
            :category="categorylist"
            @onAddProduct="addProduct"
          ></modal-add-product>
        </template>
        <template v-else>
          <div class="text-center" style="margin: 35px 0">
            <img src="/static/img/assets/ecommerce/category_tags.png" alt style="width: 300px" />
            <h3>Select category</h3>
            <a href="javascript:void(0);" class="btn btn-primary" @click="showCategory = true"
              >Add Category</a
            >
          </div>
        </template>
      </template>
      <categories
        v-model="categorylist"
        v-if="showCategory"
        @close="showCategory = false"
        @onCategoryChange="onCategoryChange"
      ></categories>
    </div>
  </div>
</template>

<script>
import Product from './Product'
import ModalAddProduct from './ModalAddProduct'
import SelectCategory from './SelectCategory'
import FilterCategory from './FilterCategory'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import Categories from './Categories'

import api from '@/api'

export default {
  data: function () {
    return {
      currentCategory: 'all',
      currentFilter: 'all',
      productlist: [],
      categorylist: [],
      selectedProduct: null,
      showCategory: false,

      loadingProduct: true,
      loadingCategory: true,

      filterBadge: {
        all: 0,
        sales: 0,
        soldout: 0
      },

      search: ''
    }
  },
  components: {
    Product,
    ModalAddProduct,
    Categories,
    SelectCategory,
    ScaleLoader,
    FilterCategory
  },
  mounted: function () {
    let vm = this
    vm.getCategories(function () {
      if (vm.categorylist.length > 0) {
        vm.onChangeCategory(vm.categorylist[0])
      }
      vm.getProducts()
      vm.loadingCategory = false
    })
  },
  computed: {
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    },
    filterProducts: function () {
      let products = []
      let vm = this
      vm.filterBadge = {
        all: vm.productlist.length,
        sales: 0,
        soldout: 0
      }

      $('body').removeClass('modal-open')
      $.each(vm.productlist, function (index, val) {
        if (parseFloat(val.price) > parseFloat(val.discountprice)) {
          vm.filterBadge.sales += 1
        }
        if (vm.currentCategory == 'sales') {
          if (parseFloat(val.price) > parseFloat(val.discountprice)) {
            products.push(val)
          }
        } else if (vm.currentCategory == val.categoryid) {
          products.push(val)
        }
        // if (val.productstock.length == 0) {
        // 	vm.filterBadge.soldout += 1
        // 	if (vm.currentCategory == 'soldout') {
        // 		products.push(val)
        // 	}
        // } else {
        // 	$.each(val.productstock,function(sindex,stock){
        // 		if (stock[2] <= 0) {
        // 			vm.filterBadge.soldout += 1
        // 			if (vm.currentCategory == 'soldout') {
        // 				products.push(val)
        // 			}
        // 			return false
        // 		}
        // 	})
        // }
      })
      if (vm.currentCategory == 'all') {
        products = vm.productlist
      }

      if (vm.search == '') {
        return products
      } else {
        return vm.productlist.filter((product) => {
          return product.name.toLowerCase().includes(vm.search.toLowerCase())
        })
      }
    }
  },
  methods: {
    onCategoryChange: function () {
      let vm = this
    },
    getCategories: function (callback) {
      let vm = this
      vm.loadingCategory = true
      api.getCategories({ pageid: vm.pageid }, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.categorylist = response.categorylist
        callback()
      })
    },
    getProducts: function () {
      let vm = this
      let data = {
        pageid: vm.pageid
      }
      vm.loadingProduct = true
      vm.productlist = []
      api.getProducts(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.loadingProduct = false
          return
        }
        vm.productlist = response.productlist
        vm.loadingProduct = false
      })
    },
    addProduct: function (product) {
      this.productlist.unshift({
        id: product.id,
        photourl: product.photourl,
        name: product.name,
        description: product.description,
        price: product.price,
        currency: product.currency,
        categoryid: product.categoryid,
        subcategoryid: product.subcategoryid,
        keyword: product.keyword,
        discountprice: product.discountprice,

        buttonaction: product.buttonaction,
        buttonname: product.buttonname,
        buttonurl: product.buttonurl,
        productstock: product.productstock
      })
    },
    onSelectProduct: function (val) {
      this.selectedProduct = this.productlist.find((product) => {
        return product.id == val
      })
    },
    onLoadCategory: function (payload) {
      // console.log(payload)
      if (payload && payload.length > 0) {
        // this.getProducts()
      }
    },
    onChangeCategory: function (payload) {
      this.currentCategory = 'all'
      this.currentFilter = 'all'
      this.search = ''
      // this.getProducts()
    },
    onDeleteProduct: function (index) {
      let vm = this
      vm.productlist.splice(index, 1)
    }
  },
  watch: {
    showCategory: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    currentCategory: function (newVal, oldVal) {
      if (newVal != null) {
        this.getProducts()
      }
    },
    productlist: function (newVal, oldVal) {
      let vm = this
      // $.each(vm.productlist,function(index ,val){
      // 	if (val.categoryid != vm.currentCategory.id) {
      // 		vm.productlist.splice(index,1)
      // 		return false;
      // 	}
      // })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/event/Place.vue